<template>
  <div v-if="visible" class="overlay">
    <div class="overlay-toolbar">
      <div class="overlay-close" @click="closeOverlay">✕</div>
    </div>
    <div class="overlay-content position-relative">
      <div class="overlay-carousel">
        <div
          id="overlayItemImageCarousel"
          class="carousel slide"
          data-touch="false"
          data-interval="false"
        >
          <div class="position-relative mx-auto carousel-wrapper">
            <div class="carousel-inner">
              <div
                v-for="(item, index) in previewImages"
                :key="index"
                :class="{
                  'carousel-item': true,
                  active: index === activeIndex,
                }"
              >
                <img class="img-fluid" :src="item" :alt="name" loading="lazy" />
              </div>
            </div>
          </div>
          <button
            class="carousel-control carousel-control-prev"
            data-target="#overlayItemImageCarousel"
            data-slide="prev"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 18L9 12L15 6"
                stroke="#121926"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
          <button
            class="carousel-control carousel-control-next"
            data-target="#overlayItemImageCarousel"
            data-slide="next"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 18L15 12L9 6"
                stroke="#121926"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
    <p class="text-center px-3">{{ name }}</p>
    <div class="overlay-thumbnail-images">
      <div
        v-for="(image, index) in carouselImages"
        :key="index"
        class="thumbnail-image"
        data-target="#overlayItemImageCarousel"
        :data-slide-to="index"
        :class="{ active: index === activeIndex }"
      >
        <img class="img-fluid" :src="image" :alt="name" loading="lazy" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "item-image-overlay",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    selectedIndex: {
      type: Number,
      default: 0,
    },
    previewImages: {
      type: Array,
      required: true,
    },
    carouselImages: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      activeIndex: 0,
      isMobile: false,
    };
  },
  methods: {
    closeOverlay() {
      this.$emit("close-overlay");
    },
    handleKeyDown(event) {
      if (event.key === "ArrowRight") {
        $("#overlayItemImageCarousel").carousel("next");
      } else if (event.key === "ArrowLeft") {
        $("#overlayItemImageCarousel").carousel("prev");
      } else if (event.key === "Escape") {
        this.closeOverlay();
      }
    },
    loadZoomPlugin() {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.id = "zoom-plugin";
        script.src = `${App.publicPath}morgenland-zoom.min.js`;

        script.addEventListener(
          "load",
          () => {
            this.initializeZoom();
            resolve();
          },
          false
        );
        script.addEventListener("error", (event) => reject(event), false);
        document.body.appendChild(script);
      });
    },
    initializeZoom() {
      if (this.isMobile) {
        let isZoomedIn = false;
        let startX,
          startY,
          currentX = 0,
          currentY = 0;

        const maxDrag = 50;

        $("#overlayItemImageCarousel .carousel-item img").on(
          "click",
          function () {
            const imgElement = $(this);
            const imgWidth = imgElement.width();
            const imgHeight = imgElement.height();

            if (!isZoomedIn) {
              imgElement.css({
                transform: "scale(2)",
                transition: "transform 0.3s ease",
                cursor: "move",
              });
              isZoomedIn = true;

              imgElement.on("touchstart", function (e) {
                const touch = e.originalEvent.touches[0];
                startX = touch.pageX - currentX;
                startY = touch.pageY - currentY;
              });

              imgElement.on("touchmove", function (e) {
                e.preventDefault();
                const touch = e.originalEvent.touches[0];
                currentX = touch.pageX - startX;
                currentY = touch.pageY - startY;

                const maxTranslateX = (imgWidth * 1.3 - imgWidth) / 2 + maxDrag;
                const maxTranslateY =
                  (imgHeight * 1.3 - imgHeight) / 2 + maxDrag;

                currentX = Math.max(
                  -maxTranslateX,
                  Math.min(currentX, maxTranslateX)
                );
                currentY = Math.max(
                  -maxTranslateY,
                  Math.min(currentY, maxTranslateY)
                );

                imgElement.css({
                  transform: `scale(2) translate(${currentX}px, ${currentY}px)`,
                  transition: "transform 0.2s ease",
                });
              });
            } else {
              imgElement.css({
                transform: "scale(1)",
                transition: "transform 0.2s ease",
                cursor: "default",
              });
              imgElement.off("touchmove");
              currentX = 0;
              currentY = 0;
              isZoomedIn = false;
            }
          }
        );
      } else {
        $("#overlayItemImageCarousel .carousel-item").zoom({
          on: "click",
          magnify: 1.5,
          duration: 300,
        });
      }
    },

    detectDeviceType() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      this.isMobile = /android|iphone|ipad|ipod/i.test(userAgent.toLowerCase());
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.detectDeviceType();
      this.loadZoomPlugin();
      this.activeIndex = this.$props.selectedIndex;
      $("#overlayItemImageCarousel").carousel();

      $("#overlayItemImageCarousel").on("slid.bs.carousel", (event) => {
        const activeItem = $(event.relatedTarget);
        this.activeIndex = activeItem.index();
      });
      document.addEventListener("keydown", this.handleKeyDown);
    });
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.handleKeyDown);
  },
};
</script>
